import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Interaction } from 'src/app/pages/interactions/interaction.model';

@Component({
  selector: 'app-audio',
  templateUrl: './audio.component.html',
  styleUrls: ['./audio.component.scss']
})
export class AudioComponent implements OnInit {

  @Input() interaction: Interaction;
  @Output() addInteraction = new EventEmitter();

  videoForm = new FormGroup({
    title: new FormControl('', [Validators.required]),
    subtitle: new FormControl(''),
    lat: new FormControl(''),
    lng: new FormControl(''),
    info: new FormControl(''),
    hasImage: new FormControl(false, [Validators.required]),
    image: new FormControl(null)
  });
  
  constructor() { }

  ngOnInit(): void {
    if (this.interaction) { // devo riempire i field
      this.populateForm();
    } else {
      this.interaction = {interactionType: 'audio'};
    }
  }

  // convenience getter for easy access to form fields
  get f(): any {
    return this.videoForm.controls;
  }

  populateForm(): void {
    this.f.title.setValue(this.interaction.title);
    this.f.subtitle.setValue(this.interaction.subtitle);
    this.interaction.interactionData && this.interaction.interactionData.info ? this.f.info.setValue(this.interaction.interactionData.info) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lat.setValue(this.interaction.interactionData.coordinates.lat) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lng.setValue(this.interaction.interactionData.coordinates.lng) : '';
    if (this.interaction.image) {
      this.f.hasImage.setValue(true);
      this.f.image.setValue(this.interaction.image);
    }
  }

  setImageUrl(event): void {
    if (event) {
      this.f.image.setValue(event.filename);
    } else {
      this.f.image.setValue(null);
    }
    this.interaction.image = this.f.image.value;
  }

  setAudioFile(event): void {
    if (event) {
      this.interaction.interactionData = {audioUrl: event.filename};
    } else {
      this.interaction.interactionData = {audioUrl: null};
    }
  }

  validateTitle(): boolean {
    return !this.f.title.errors && !this.f.subtitle.errors;
  }

  setTitle(): void {
    this.interaction.title = this.f.title.value;
    this.interaction.subtitle = this.f.subtitle.value;
  }

  validateContenuto(): boolean {
    let valid = true;
    if (this.f.hasImage.value) {
      if (!this.f.image.value) {
        valid = false;
      }
    }
    if (!this.interaction.interactionData || !this.interaction.interactionData.audioUrl) {
      valid = false;
    }
    return valid;
  }

  onAddInteraction(): void {
    this.f.hasImage.value ? this.interaction.image = this.f.image.value : '';
    this.interaction.interactionData.info = this.f.info.value;
    this.interaction.interactionData.coordinates = {
      lat: this.f.lat.value,
      lng: this.f.lng.value
    }
    this.addInteraction.emit(this.interaction);
  }

}
